import { useTranslation } from "react-i18next";
import AppConfigContext from "../../context/AppConfigContext";
import { useContext } from "react";
import { getProgramTypeFromSubdomain } from "../../utils/utils";
import { PROGRAM_TYPE } from "../../utils/constants";

const FormHeader = ({ step }) => {
    const { config } = useContext(AppConfigContext)
    const { t } = useTranslation(config.theme, { keyPrefix: "header" });
    // The C-SNP variant overrides only the keys it names under "csnp"; every other key is the D-SNP copy.
    const csnp = getProgramTypeFromSubdomain() === PROGRAM_TYPE.CSNP;
    const tv = (key) => csnp ? t([`csnp.${key}`, key]) : t(key);

    if (step !== 1) {
        return <></>
    }

    return (
        <div className="bg-primary p-4 text-white">
            <p>{t("content1")}</p>

            <ul>
                <li>{tv("list1")}</li>
                <li>{t("list2")}</li>
                <li>{t("list3")}</li>
                <li>{t("list4")}</li>
                <li>{t("list5")}</li>
            </ul>

            <p className="fw-bold mb-0">{t("content2")}</p>
        </div>
    );
}

export default FormHeader;
